"use client";

import { Mail, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
function IrisMark({
  className = ""
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </svg>;
}
const tickerText = "HOTELREVBABA  ·  REVENUE MANAGEMENT";
const services = [{
  label: "Revenue Management Consulting",
  to: "/RevenueManagementConsultingPage"
}, {
  label: "OTA Revenue Optimization",
  to: "/OTARevenueManagementListingsPage"
}, {
  label: "Hotel SEO",
  to: "/HotelSEODigitalMarketingServicesPage"
}, {
  label: "Hotel Paid Ads",
  to: "/HotelAdsPaidMediaServicesPage"
}, {
  label: "Hotel Website Development",
  to: "/HighConvertingHotelWebsiteDesignOptimizationPage"
}];
const resources = [{
  label: "Google Hotel Ads",
  to: "/HotelAdsPaidMediaServicesPage"
}, {
  label: "Meta Advertising",
  to: "/HotelAdsPaidMediaServicesPage"
}, {
  label: "TripAdvisor Marketing",
  to: "/OTARevenueManagementListingsPage"
}, {
  label: "Revenue Blog",
  to: "/BlogPage"
}, {
  label: "Commercial Insights",
  to: "/BlogPage"
}, {
  label: "About Agency",
  to: "/AboutPage"
}, {
  label: "Contact/Support",
  to: "/ContactPage"
}];
export default function FooterInformation() {
  return <section data-section-id="1798" id="footer-information" className="bg-[#0B4D9C] text-white py-16 relative overflow-hidden font-sans">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center">
        <span className="w-2 h-2 bg-secondary -ml-1" />
        <span className="flex-1 h-px bg-secondary/30" />
        <span className="w-2 h-2 bg-secondary -mr-1" />
      </div>

      {}
      <div className="relative overflow-hidden border-b border-white/10 group">
        <div className="flex whitespace-nowrap py-5 group-hover:[animation-play-state:paused]" style={{
        animation: "footer-ticker 40s linear infinite"
      }}>
          {[0, 1, 2, 3].map(rep => <div key={rep} data-index={rep} className="flex items-center font-mono text-xs tracking-[0.18em] uppercase text-white/60 shrink-0">
              {tickerText.split("·").map((chunk, i) => <span key={i} data-index={i} className="flex items-center">
                  <span className="px-4">{chunk.trim()}</span>
                  <IrisMark className="w-3 h-3 text-secondary shrink-0" />
                </span>)}
            </div>)}
        </div>
        <style>{`
          @keyframes footer-ticker {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-12">
        {}
        <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50 mb-12">
          § 09 — HOTELREVBABA · REVENUE ARCHITECTS
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-8">
            <div className="flex items-center gap-3">
              <Link to="/" className="flex items-center gap-3">
                <WvcLogo className="h-7 w-auto" />
              </Link>
              <IrisMark className="w-6 h-6 text-secondary" />
            </div>

            <div className="flex flex-col gap-5">
              <p className="font-sans text-lg leading-relaxed text-white/90">
                Maximizing hotel revenue through data-driven OTA strategies.
              </p>
              <div className="flex items-center gap-3">
                <span className="w-10 h-px bg-secondary" />
                <span className="w-1 h-1 bg-secondary rounded-lg" />
              </div>
              <p className="font-mono text-xs tracking-[0.12em] uppercase text-white/60 leading-relaxed">
                Global Consulting
                <br />
                Available for Partnerships
              </p>
              <p className="font-mono text-xs tracking-[0.12em] uppercase text-white/60">
                hotelrevbaba@gmail.com
              </p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Services
            </div>
            <nav>
              <ul className="flex flex-col gap-3">
                {services.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="text-white/80 hover:text-white font-sans text-sm tracking-wide relative inline-block group transition-colors">
                      <span className="relative">
                        {item.label}
                        <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                      bottom: "-4px"
                    }} />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Resources
            </div>
            <nav>
              <ul className="flex flex-col gap-3">
                {resources.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="text-white/80 hover:text-white font-sans text-sm tracking-wide relative inline-block group transition-colors">
                      <span className="relative">
                        {item.label}
                        <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                      bottom: "-4px"
                    }} />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/50">
              Contact
            </div>
            <ul className="flex flex-col gap-4">
              <li data-index={0}>
                <Link to="https://wa.me/917972195929" newTab className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <MessageCircle className="w-4 h-4 stroke-[1.5]" />
                  <span className="relative">
                    WhatsApp
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="mailto:hotelrevbaba@gmail.com" className="text-white/80 hover:text-white font-sans text-sm tracking-wide inline-flex items-center gap-3 group transition-colors">
                  <Mail className="w-4 h-4 stroke-[1.5]" />
                  <span className="relative">
                    Email Us
                    <span className="absolute left-0 right-0 h-px bg-secondary transition-all duration-300 scale-x-0 group-hover:scale-x-100 origin-left" style={{
                    bottom: "-4px"
                  }} />
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mt-20 flex items-center">
          <span className="w-2 h-2 bg-secondary rounded-lg" />
          <span className="flex-1 h-px bg-secondary/30" />
          <span className="w-2 h-2 bg-secondary rounded-lg" />
        </div>

        {}
        <div className="flex justify-center my-12">
          <IrisMark className="w-12 h-12 md:w-14 md:h-14 text-secondary" />
        </div>

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-mono text-[0.6875rem] tracking-[0.18em] uppercase text-white/40">
            © 2026 HOTELREVBABA · REVENUE MANAGEMENT
          </p>
          <ul className="flex items-center gap-6 md:gap-8">
            {[{
            label: "Terms",
            to: "#"
          }, {
            label: "Privacy",
            to: "#"
          }, {
            label: "Legal",
            to: "#"
          }].map((item, i) => <li key={item.label} data-index={i}>
                <Link to={item.to} className="text-white/40 font-mono text-[0.6875rem] tracking-[0.18em] uppercase hover:text-secondary transition-colors duration-300">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      {}
      <div className="md:hidden">
        <Link to="https://wa.me/917972195929?text=Hello%20HotelRevBaBa,%20I%20would%20like%20to%20inquire%20about%20your%20revenue%20management%20services." newTab aria-label="Chat with us on WhatsApp">
          <Button className="fixed bottom-4 right-4 z-50 w-14 h-14 rounded-lg bg-[#25D366] hover:bg-[#25D366]/90 text-white shadow-lg p-0 flex items-center justify-center">
            <MessageCircle className="w-7 h-7 stroke-[1.5]" />
          </Button>
        </Link>
      </div>
    </section>;
}